/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiQueue,
    ApiQueueFromJSON,
    ApiQueueFromJSONTyped,
    ApiQueueToJSON,
} from './ApiQueue';

/**
 * 
 * @export
 * @interface ApiStreamingQueueMessage
 */
export interface ApiStreamingQueueMessage {
    /**
     * 
     * @type {object}
     * @memberof ApiStreamingQueueMessage
     */
    end?: object;
    /**
     * 
     * @type {ApiQueue}
     * @memberof ApiStreamingQueueMessage
     */
    queue?: ApiQueue;
}

export function ApiStreamingQueueMessageFromJSON(json: any): ApiStreamingQueueMessage {
    return ApiStreamingQueueMessageFromJSONTyped(json, false);
}

export function ApiStreamingQueueMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiStreamingQueueMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'end': !exists(json, 'end') ? undefined : json['end'],
        'queue': !exists(json, 'queue') ? undefined : ApiQueueFromJSON(json['queue']),
    };
}

export function ApiStreamingQueueMessageToJSON(value?: ApiStreamingQueueMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'end': value.end,
        'queue': ApiQueueToJSON(value.queue),
    };
}

